export default __webpack_public_path__ + "static/media/solana-logo.88dd9cd2.png";